<template>
  <!-- ▼Main Container -->
  <div class="boss-main-container">
    <div class="boss-main-wrap boss-main-content-wrap">
      <setting-header
        :breadcrumbs="[{ name: '求人確認' }]"
        title="掲載前の求人"
      />
      <div class="grid-x align-justify">
        <div class="medium-9 cell">
          <p>掲載前の求人を確認します。</p>
        </div>
      </div>
      <section>
        <job-publish-section-title
          title="求人情報プレビュー"
          description="修正に関するコメント、制作担当とのメッセージ確認は「求人」ボタンからご確認ください。"
        />
        <job-pre-published-jobs
          :jobs="jobOption.jobList"
          :photoclip-ids="jobOption.photoclipIdList"
          :interview-ids="jobOption.interviewIdList"
        />
      </section>
      <section class="margin-top-1">
        <job-publish-section-title title="企業情報プレビュー" />
        <job-pre-published-company :company="company" />
      </section>
    </div>
  </div>
</template>

<script>
import SettingHeader from '@/components/atoms/SettingHeader'
import JobPublishSectionTitle from '@/components/molecules/JobPublishSectionTitle'
import JobPrePublishedJobs from '@/components/organisms/JobPrePublishedJobs'
import JobPrePublishedCompany from '@/components/organisms/JobPrePublishedCompany'

export default {
  components: {
    SettingHeader,
    JobPublishSectionTitle,
    JobPrePublishedJobs,
    JobPrePublishedCompany
  },
  data () {
    return {
      jobOption: {
        jobList: [],
        photoclipIdList: [],
        interviewIdList: []
      },
      company: null
    }
  },
  created () {
    this.fetchPrePublishJobs()
    this.fetchPrePublishCompany()
  },
  methods: {
    fetchPrePublishJobs () {
      this.$http.secured.get('/preview/prepublish/jobs').then(response => {
        this.$set(this, 'jobOption', response.data)
      })
    },
    fetchPrePublishCompany () {
      this.$http.secured.get('/preview/prepublish/company').then(response => {
        this.$set(this, 'company', response.data || null)
      })
    }
  }
}
</script>
